import PropTypes from 'prop-types';
import isString from 'lodash/isString';
import { m, AnimatePresence } from 'framer-motion';
// @mui
import { alpha } from '@mui/material/styles';
import { List, Stack, Button, IconButton, ListItemText, ListItem,Typography,Box,Grid } from '@mui/material';
// utils
import { fData } from '../../utils/formatNumber';
//
import Image from '../Image';
import Iconify from '../Iconify';
import { varFade } from '../animate';

// ----------------------------------------------------------------------

const getFileData = (file) => {
  if (typeof file === 'string') {
    return {
      key: file,
    };
  }
  return {
    key: file.name,
    name: file.name,
    size: file.size,
    preview: file.preview,
  };
};

// ----------------------------------------------------------------------

MultiFilePreview.propTypes = {
  files: PropTypes.array,
  showPreview: PropTypes.bool,
  onRemove: PropTypes.func,
  onRemoveAll: PropTypes.func,
};

export default function MultiFilePreview({ showPreview = false, files, onRemove, onRemoveAll,onOpenModel }) {
  const hasFile =  files && files.length > 0;

  return (
    <>
      <List disablePadding sx={{ ...(hasFile && { my: 3 }) }}>
        <AnimatePresence>
          {files && files.map((file) => {
            const { key, name, size, preview } = getFileData(file);

            if (showPreview) {
              return (
                <Grid container xs={12} md={12} sx={{display:'flex'}} >
                  <Grid item xs={12} md={12} sx={{alignItems:'center'}}>
                    <ListItem
                      key={key}
                      component={m.div}
                      {...varFade().inRight}
                      className="ImgManageList"
                      sx={{
                        p: 0,
                        m: 0.5,
                        width: 90,
                        height: 80,
                        borderRadius: 1.25,
                        overflow: 'hidden',
                        position: 'relative',
                        display: 'inline-flex',
                        border: (theme) => `solid 1px ${theme.palette.divider}`,
                      }}
                    >
                      <Image alt="preview" src={isString(file) ? file : preview} ratio="1/1" />
                      <IconButton
                        size="small"
                        onClick={() => onRemove(file)}
                        sx={{
                          top: 6,
                          p: '2px',
                          right: 6,
                          position: 'absolute',
                          color: 'common.white',
                          bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
                          '&:hover': {
                            bgcolor: (theme) => alpha(theme.palette.grey[900], 0.48),
                          },
                        }}
                      >
                        <Iconify icon={'eva:close-fill'} />
                      </IconButton>
                    </ListItem>
                    <Typography sx={{m:1,mt:0}}>{file && file.name && file.name.length > 0 ?file.name.length > 12 ? file.name.substring(0, 12) + "..." : file.name : ''}</Typography>
                  </Grid>
                </Grid>
              );
            }

            return (
              <ListItem
                key={key}
                component={m.div}
                {...varFade().inRight}
                sx={{
                  my: 1,
                  px: 2,
                  py: 0.75,
                  borderRadius: 0.75,
                  border: (theme) => `solid 1px ${theme.palette.divider}`,
                }}
              >
                <Iconify icon={'eva:file-fill'} sx={{ width: 28, height: 28, color: 'text.secondary', mr: 2 }} />

                <ListItemText
                  primary={isString(file) ? file : name}
                  secondary={isString(file) ? '' : fData(size || 0)}
                  primaryTypographyProps={{ variant: 'subtitle2' }}
                  secondaryTypographyProps={{ variant: 'caption' }}
                />
                <IconButton edge="end" size="small" onClick={() => onRemove(file)}>
                  <Iconify icon={'eva:close-fill'} />
                </IconButton>
              </ListItem>
            );
          })}
        </AnimatePresence>
      </List>

      {hasFile && (
        <Stack direction="row" justifyContent="flex-end" spacing={1.5}>
          <Button color="inherit" size="small" onClick={onRemoveAll}>
            Remove all
          </Button>
          {/* <Button size="small" variant="contained" onClick={onOpenModel}> */}
          <Button size="small" variant="contained" type="submit">
            Upload files
          </Button>
        </Stack>
      )}
    </>
  );
}
